import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import './index.scss';
import { message, Button } from 'antd';
import star from 'asset/img/star-hd.svg';
import unstar from 'asset/img/unstar-hd.svg';
import silme from 'asset/img/silme.png';
import magic from 'asset/img/magic.png';
import check from 'asset/img/check.png';
import uncheck from 'asset/img/uncheck.png';
import back from 'asset/img/back.png';
import wrong from 'asset/img/wrong.png';
import right from 'asset/img/right.png';
import empty from 'asset/img/empty.png';
// import goon from 'asset/music/goon.mp3'; // 改用 Web Audio API
import { playLevelCompleteSoundSynthetic, playLevelCompleteSoundByStars, playSkillSound, playSuccessSound, playErrorSound, playTreasureBoxOpenSound, stopDetailSuccSound } from 'utils/soundEffect';
import openLiwuMusic from 'asset/music/openLiwu.mp3';
import { useLocation, useNavigate } from 'react-router-dom';
import WkModal from 'components/Modal'
import Loadding from 'components/Loadding'
import AssessmentAiLoading from 'components/AssessmentAiLoading'
import { getCourseDetail, studyDoneSubmit, studyDoneReward, getUserInfo, getGardenInfo, getStorRewadRecord } from 'network';
import { useDispatch } from 'react-redux';
import { setUser } from 'actions';
import { savePetInfoToStorage, getPetInfoFromStorage } from 'utils/petStorage';
import { getTreasureBoxCoin, getBaseCoin } from 'utils/reward';
import { rollTreasureFood } from 'constants/treasureFoods';
import TreasureBoxModal from 'components/TreasureBoxModal';
import Wheel from 'components/Wheel';
import PetAvatar from 'components/PetAvatar';
import Fireworks from 'components/Fireworks';
import music from 'asset/img/laba.png';
import avator1 from 'asset/img/detail-avator-1.webp';
import avator2 from 'asset/img/detail-avator-2.webp';
import gold from 'asset/img/gold.svg';
import { OssAudio, OssImg, OssOther, ossImageUrl, agent, canAccessAllLevels } from 'utils/const.js';
import { checkWebpSupport, isWebpSupported } from 'utils/webpSupport';
import { calcSerial, calcSkill } from 'utils';
import { normalizeAnswerText } from 'utils/answerText';
import { Tooltip } from 'antd';
import Timer from './Timer';
import Word from './Word';
import openLiwu from 'asset/img/openLiwu.webp';
import unopenLiwu from 'asset/img/unopenLiwu.webp';

// 关卡上限：历史版本为 500 关
const MAX_LEVEL = 500;

// 测评关卡：serial_id=111，仅 1 关，该关内 7 个小关（进度 1/7），通关后跳转 pet
const ASSESSMENT_SERIAL_ID = 111;
const ASSESSMENT_LEVEL = 1;
const ASSESSMENT_SUB_LEVELS = 7; // 测评这一关里的小关数量，用于进度显示 1/7
const ASSESSMENT_AI_LOADING_TEXTS = [
  '悟空正在分析听觉反应节奏…',
  '悟空正在匹配右脑高频输入强度…',
  '悟空正在生成专属训练路径…',
];
// 15 关测评第 8 关结束后展示的假 AI loading（两段，各 1.2 秒）
const ASSESSMENT_AI_LOADING_MID_TEXTS = [
  '已根据表现微调输入比例',
  '后续训练难度已优化',
];

// 是否显示「还剩几关」宝箱倒数（隐藏时不删代码，仅不渲染）
const SHOW_BOX_REMAINING_COUNTDOWN = false;

const DUJING_XIAOSHI_SERIAL = 985; // 读经小士(小雷音寺) serial，用于家长须知等

// 影视 serial_id -> slide 索引：985-988 第1页，989-991 第2页，992-994 第3页
const getYingshiSlideIndex = (serialId) => {
    const sid = Number(serialId);
    if (sid >= 989 && sid <= 991) return 1;
    if (sid >= 992 && sid <= 994) return 2;
    return 0;
};

const DAILY_LEVEL_LIMIT_KEY = 'limit-data-global-v2';
const DAILY_LEVEL_LIMIT = 30;
const LEGACY_LIMIT_KEY = 'limit-data';
const LEGACY_YINGSHI_LIMIT_KEY = 'limit-data-yingshi';

const getTodayKey = () => new Date().toISOString().split('T')[0];

const readLimitStorage = (key) => {
    const rawData = localStorage.getItem(key);
    if (!rawData) return { count: 0, lastDate: '' };
    try {
        const data = JSON.parse(rawData);
        return { count: Number(data?.count) || 0, lastDate: data?.lastDate || '' };
    } catch {
        return { count: 0, lastDate: '' };
    }
};

const getDailyLevelLimitData = () => {
    const today = getTodayKey();
    const current = readLimitStorage(DAILY_LEVEL_LIMIT_KEY);
    if (current.lastDate === today) return current;

    // 兼容旧版本当天已经产生的计数。影视旧逻辑会同时写普通计数和影视计数，
    // 这里取最大值，避免升级当天把同一关重复算两次。
    const legacy = readLimitStorage(LEGACY_LIMIT_KEY);
    const legacyYingshi = readLimitStorage(LEGACY_YINGSHI_LIMIT_KEY);
    const migratedCount = Math.max(
        legacy.lastDate === today ? legacy.count : 0,
        legacyYingshi.lastDate === today ? legacyYingshi.count : 0
    );
    return { count: migratedCount, lastDate: today };
};

const saveDailyLevelLimitData = (data) => {
    localStorage.setItem(DAILY_LEVEL_LIMIT_KEY, JSON.stringify(data));
};

const checkDailyLevelLimit = () => getDailyLevelLimitData().count < DAILY_LEVEL_LIMIT;

const incrementDailyLevelLimit = () => {
    const limitData = getDailyLevelLimitData();
    saveDailyLevelLimitData({
        count: (Number(limitData.count) || 0) + 1,
        lastDate: getTodayKey()
    });
};

// 背景图路径映射 - 按需动态加载（带 webp 降级）
const backgroundPathsWebp = {
    'yingshi-0': () => import('asset/img/background4.webp'),
    'yingshi-1': () => import('asset/img/background5.webp'),
    'yingshi-2': () => import('asset/img/background6.webp'),
    '0-0': () => import('asset/img/bk-menu-01-01.webp'),
    '0-1': () => import('asset/img/bk_detail_01_01.webp'),
    '0-2': () => import('asset/img/bk_detail_01_02.webp'),
    '0-3': () => import('asset/img/bk-menu-01-04.webp'),
    '1-0': () => import('asset/img/bk_detail_02_01.webp'),
    '1-1': () => import('asset/img/bk-menu-02-01.webp'),
    '1-2': () => import('asset/img/bk_detail_02_02.webp'),
    '1-3': () => import('asset/img/bk_detail_02_01.webp'),
    '2-0': () => import('asset/img/bk-menu-03-01.webp'),
    '2-1': () => import('asset/img/bk_detail_03_01.webp'),
    '2-2': () => import('asset/img/bk_detail_03_02.webp'),
    '2-3': () => import('asset/img/bk-menu-03-03.webp'),
};

// PNG 降级路径（影视背景暂无 png，用 webp 兜底）
const backgroundPathsPng = {
    'yingshi-0': () => import('asset/img/background4.webp'),
    'yingshi-1': () => import('asset/img/background5.webp'),
    'yingshi-2': () => import('asset/img/background6.webp'),
    '0-0': () => import('asset/img/bk-menu-01-01.png'),
    '0-1': () => import('asset/img/bk_detail_01_01.png'),
    '0-2': () => import('asset/img/bk_detail_01_02.png'),
    '0-3': () => import('asset/img/bk-menu-01-04.png'),
    '1-0': () => import('asset/img/bk_detail_02_01.png'),
    '1-1': () => import('asset/img/bk-menu-02-01.png'),
    '1-2': () => import('asset/img/bk_detail_02_02.png'),
    '1-3': () => import('asset/img/bk_detail_02_01.png'),
    '2-0': () => import('asset/img/bk-menu-03-01.png'),
    '2-1': () => import('asset/img/bk_detail_03_01.png'),
    '2-2': () => import('asset/img/bk_detail_03_02.png'),
    '2-3': () => import('asset/img/bk-menu-03-03.png'),
};

// 工具函数 - 移到组件外部避免重复创建
const shuffleArray = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
};

const shuffleNestedArrays = (data) => {
    return data.map(item => ({
        ...item,
        images: shuffleArray(item.images)
    }));
};

const resolveAssetUrl = (baseUrl, src) => {
    if (!src || typeof src !== 'string') return '';
    const normalizedSrc = src.trim();
    if (/^(https?:)?\/\//i.test(normalizedSrc) || /^(data|blob):/i.test(normalizedSrc)) {
        return normalizedSrc;
    }
    return `${baseUrl}${normalizedSrc.startsWith('/') ? normalizedSrc : `/${normalizedSrc}`}`;
};

const shouldUseCourseAudioSrc = (src) => {
    if (!src || typeof src !== 'string') return false;
    const normalizedSrc = src.trim();
    return /^(https?:)?\/\//i.test(normalizedSrc)
        || /^(data|blob):/i.test(normalizedSrc)
        || normalizedSrc.startsWith('/tts/')
        || normalizedSrc.startsWith('tts/');
};

const Detail = () => {
    const dispatch = useDispatch();
    const controllerRef = useRef(null);
    const [tipVisible, setTipVisible] = useState(false);
    const wordtimerRef = useRef(null);
    const audiotimerRef = useRef(null);
    // 选择图片相关的定时器 refs
    const selectTimerRef = useRef(null);
    const resultTimerRef = useRef(null);
    const errorTimerRef = useRef(null);
    const selectPictureThrottleRef = useRef(0); // 节流：限制点击频率，防止小朋友连点卡顿
    const selectPictureLockRef = useRef(false); // 处理中锁：防止 setState 未生效前的连点或 touch+click 双触发
    const assessmentFirstHintShownRef = useRef(false);
    let navigate = useNavigate();
    const location = useLocation();
    // 页面类型
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get('type');
    const index = searchParams.get('index');
    const fromYingshi = searchParams.get('from') === 'yingshi';
    const yingshiSerialId = searchParams.get('serial_id');
    // demo 彩蛋模式：只影响 demo=1 的分支，不干扰其他正常关卡逻辑
    const demoMode = searchParams.get('demo') === '1';
    const demoMenuSerialId = searchParams.get('demo_menu_serial_id');
    const demoContentSerialId = searchParams.get('demo_serial_id');
    const isAssessmentMode = searchParams.get('assessment') === '1';
    // 测评模式测试用：URL 加 eng_level=0 可强制进入 7 关类型（0 基础），方便测试 AI loading
    const engLevelOverride = searchParams.get('eng_level');
    // 调试用：URL 加 debug_ai_loading=1 可一直展示假 AI loading，方便本地调 UI
    const debugAiLoading = searchParams.get('debug_ai_loading') === '1';
    const [coin, setCoin] = useState(0);
    const [score, setScore] = useState(0);
    const [errorNumber, setErrorNumber] = useState(0);
    const [user, setUser] = useState({});
    const [pet, setPet] = useState({});
    const [lazyData, setLazyData] = useState(false);

    // 当前关数（测评模式固定为 1）
    const level = Number(searchParams.get('level'));
    const [levelIndex, setLevelIndex] = useState(isAssessmentMode ? ASSESSMENT_LEVEL : Math.min(level || 1, MAX_LEVEL));
    // 用户进入时的最高关卡（用于判断是否是新关卡）
    const maxLevelParam = Number(searchParams.get('maxLevel') || level);
    const maxLevelRef = useRef(maxLevelParam);
    // URL 中 level/maxLevel 变化时同步 ref，保证进入页时的每日限制判断用对“是否新关卡”
    useEffect(() => {
        maxLevelRef.current = maxLevelParam;
    }, [maxLevelParam]);
    // 宝箱是否已打开（从 menu 页面传递）
    const boxOpenedParam = searchParams.get('boxOpened') === '1';
    
    // 当 URL 参数变化时，更新 boxOpened 状态
    useEffect(() => {
        setBoxOpened(boxOpenedParam);
    }, [boxOpenedParam, levelIndex]);
    // 技能1
    const [skill1Status, setSkill1Status] = useState(false);
    // const [skillGifStatus, setSkillGifStatus] = useState(false);
    // 关内进度
    const [count, setCount] = useState(0);
    const [countIndex, setCountIndex] = useState(0);
    // 关卡进度条
    // 或者12.5 当图片为8时
    const [progressIndex, setProgressIndex] = useState(6.67);
    const [progress, setProgress] = useState(demoMode ? 0 : progressIndex);
    const [data, setData] = useState(Array.from({ length: 10 }, () => { return { src: '' } }))
    const [imagesList, setImagesList] = useState([])
    const [audio, setAudio] = useState(null);
    const [wheelVisible, setWheelVisible] = useState(false);
    const [skillVisible, setSkillVisible] = useState(false);
    const [skillList, setskillList] = useState([
        { number: 1, src: OssOther + '/image/skill/skill1.png', visible: true },
        { number: '(被动)', src: OssOther + '/image/skill/skill2.png', visible: false },
        { number: '(被动)', src: OssOther + '/image/skill/skill3.png', visible: false },
        { number: '(被动)', src: OssOther + '/image/skill/skill4.png', visible: false },
    ]);
    const [wordVisable, setWordVisable] = useState(true);
    const [wordStatus, setWordStatus] = useState(false);
    // const [luckAudio, setLuckAudio] = useState('');
    // const [luckySrc, setLuckySrc] = useState([]);
    // 句子
    const [words, setWords] = useState(['']);
    // 字体组件
    const wordRef = useRef(null);

    const [resultIndex, setResultIndex] = useState('');
    const [resultStatus, setResultStatus] = useState(false);
    const imagesListRef = useRef([]);
    const audioRef = useRef(null);
    const audioSuccessRef = useRef(null);
    const audioErrorRef = useRef(null);
    const audioGoonRef = useRef(null);
    const magicAudioRef = useRef(null);
    const audioOpenLiwuMusic = useRef(null); // 宝箱音效
    // 控制时间组件
    const timerRef = useRef(null);
    // 控制时间暂停
    const [timePause, setTimePause] = useState(false);
    const [successVisible, setSuccessVisible] = useState(false);
    const [whVisible, setWhVisible] = useState(false);
    const [baseCoin, setBaseCoin] = useState(0); // P0优化：每关基础金币
    const [boxVisible, setBoxVisible] = useState(false); // 宝箱弹窗显示
    const [boxCoin, setBoxCoin] = useState(0); // 宝箱金币
    const [boxFood, setBoxFood] = useState(null); // 宝箱 30% 概率开出的食物
    const [boxOpened, setBoxOpened] = useState(boxOpenedParam); // 宝箱是否已打开（从 menu 传递）
    const [assessmentCompleteVisible, setAssessmentCompleteVisible] = useState(false); // 测评通关专用弹窗
    const [assessmentAiLoadingVisible, setAssessmentAiLoadingVisible] = useState(false);
    const [assessmentAiLoadingText, setAssessmentAiLoadingText] = useState('');
    const [assessmentAiLoadingTexts, setAssessmentAiLoadingTexts] = useState(null); // 顺序展示多条，每条 1 秒
    const assessmentAiLoadingPendingRef = useRef(null);
    const onAssessmentAiLoadingComplete = useCallback(() => {
        const fn = assessmentAiLoadingPendingRef.current;
        assessmentAiLoadingPendingRef.current = null;
        setAssessmentAiLoadingVisible(false);
        setAssessmentAiLoadingTexts(null);
        if (typeof fn === 'function') fn();
    }, []);

    // 测评模式：111；影视入口：URL 的 serial_id；Home：calcSerial(type, index)
    const effectiveSerialId = isAssessmentMode
        ? ASSESSMENT_SERIAL_ID
        : (fromYingshi && yingshiSerialId ? Number(yingshiSerialId) : calcSerial(type, index));
    // 测评 s111 的 7 关/15 关：优先 URL 的 eng_level=0（测试 7 关），否则用 user.data.english_level
    const effectiveEngLevel = (isAssessmentMode && (engLevelOverride === '0' || engLevelOverride === '启蒙0基础'))
        ? '启蒙0基础'
        : user?.data?.english_level;
    const menuUrl = useMemo(() => {
        if (fromYingshi) {
            if (yingshiSerialId) {
                if (demoMode) {
                    const menuSid = demoMenuSerialId || yingshiSerialId;
                    const contentSid = demoContentSerialId || yingshiSerialId;
                    return `/menu?from=yingshi&serial_id=${menuSid}&demo=1&demo_serial_id=${contentSid}`;
                }
                return `/menu?from=yingshi&serial_id=${yingshiSerialId}`;
            }
            return '/yingshi'; // 影视入口缺 serial_id 时退回影视页，避免 undefined
        }
        return `/menu?type=${type}&index=${index}`;
    }, [fromYingshi, yingshiSerialId, type, index, demoMode, demoMenuSerialId, demoContentSerialId]);
    const buildDetailUrl = useCallback(
        (level, maxLevel, boxOpened) => {
            if (fromYingshi) {
                if (yingshiSerialId) return `/detail?from=yingshi&serial_id=${yingshiSerialId}&level=${level}&maxLevel=${maxLevel}&boxOpened=${boxOpened ? '1' : '0'}`;
                return '/yingshi'; // 缺 serial_id 时不拼 detail，退回影视页
            }
            return `/detail?type=${type}&index=${index}&level=${level}&maxLevel=${maxLevel}&boxOpened=${boxOpened ? '1' : '0'}`;
        },
        [fromYingshi, yingshiSerialId, type, index]
    );

    // 仅把第4关的宝箱前置到第3关（写死），后面还是8、12、16、20、24、28，31关后每6关一次
    const isBoxLevel = useMemo(() => {
        const level = levelIndex;
        if (level <= 30) return level === 3 || (level >= 8 && level % 4 === 0);
        return level % 6 === 0;
    }, [levelIndex]);
    
    // 计算下一个宝箱关卡和进度（考虑500关限制）
    const getNextRewardInfo = useCallback(() => {
        const currentLevel = levelIndex;
        let nextRewardLevel = null;
        let remaining = 0;
        
        if (currentLevel <= 30) {
            // 前30关宝箱：3（前置）、8、12、16、20、24、28
            const boxLevels = [3, 8, 12, 16, 20, 24, 28];
            const idx = boxLevels.findIndex((l) => l >= currentLevel);
            if (idx === -1) {
                nextRewardLevel = 36;
                remaining = 36 - currentLevel;
            } else if (boxLevels[idx] === currentLevel) {
                nextRewardLevel = boxLevels[idx + 1] ?? 36;
                remaining = (boxLevels[idx + 1] ?? 36) - currentLevel;
            } else {
                nextRewardLevel = boxLevels[idx];
                remaining = boxLevels[idx] - currentLevel;
            }
        } else {
            // 31关后：每6关一次（36, 42, 48, 54...）
            const remainder = currentLevel % 6;
            if (remainder === 0) {
                // 当前就是宝箱关，下一个是6关后
                nextRewardLevel = currentLevel + 6;
                remaining = 6;
            } else {
                // 下一个宝箱关
                nextRewardLevel = currentLevel + (6 - remainder);
                remaining = 6 - remainder;
            }
        }
        
        // 如果下一个宝箱关卡超过上限，则不再显示提示
        if (nextRewardLevel > MAX_LEVEL) {
            return { nextRewardLevel: null, remaining: 0 };
        }
        
        return { nextRewardLevel, remaining };
    }, [levelIndex]);
    
    // 使用工具函数获取宝箱金币
    const getRandomWeightedNumber = useCallback(() => {
        return getTreasureBoxCoin(pet);
    }, [pet]);
    
    // 打开宝箱 - 增强版音效和画面效果；30% 概率额外开出食物
    const handleOpenBox = useCallback(() => {
        if (boxOpened) return; // 已打开，不再处理
        stopDetailSuccSound(); // 开宝箱前终止闯关成功音
        const coin = getRandomWeightedNumber();
        const food = rollTreasureFood(); // 30% 概率返回一项食物
        setBoxCoin(coin);
        setBoxFood(food);
        setBoxOpened(true);

        // 关闭其他弹窗
        setSuccessVisible(false);
        setWheelVisible(false);
        setWhVisible(false);

        // 播放增强版音效（Web Audio API，不占用内存）
        playTreasureBoxOpenSound();

        // 调用接口保存（含可选 goods_id），成功后拉取最新用户信息
        const payload = {
            serial_id: effectiveSerialId,
            number: levelIndex,
            coin,
            type: 2,
        };
        if (food?.goods_id) payload.goods_id = food.goods_id;
        studyDoneReward(payload).then(() => {
            getUserInfo({}).then((r) => {
                if (r?.data) dispatch(setUser(r.data));
            }).catch(() => {});
        }).catch(err => {
            console.error('打开宝箱失败:', err);
        });

        // 播放宝箱音效
        if (audioOpenLiwuMusic.current) {
            audioOpenLiwuMusic.current.play().catch(err => {
                console.log('播放宝箱音效失败:', err);
            });
        }

        setBoxVisible(true);
    }, [boxOpened, levelIndex, effectiveSerialId, getRandomWeightedNumber, dispatch]);

    const _skillRef = {
        0: { count: -1, countIndex: -1 },
        1: { count: -1, countIndex: -1 },
        2: { count: -1, countIndex: -1 },
        3: { count: -1, countIndex: -1 }
    }
    const skillRef = useRef(_skillRef);
    const [isFifteenthLoaded, setIsFifteenthLoaded] = useState(false);
    const [musk, setMusk] = useState(true);
    
    // 用于追踪上一个 level，检测 level 变化
    const prevLevelRef = useRef(level);
    // 记录最近一次已加载课程详情的关卡，避免同一关在抽奖/弹窗状态切换时被重复拉取导致音频重播
    const lastLoadedLevelRef = useRef(null);
    
    // 当 URL 中的 level 变化时，重置状态（不需要重新挂载组件）
    useEffect(() => {
        if (prevLevelRef.current !== level && level > 0) {
            // level 变化了，重置关键状态
            prevLevelRef.current = level;
            
            // 1. 先停止音频，释放资源
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }
            
            // 2. 清空图片数据，帮助垃圾回收
            setImagesList([]);
            setData([]);
            
            // 3. 重置其他状态
            setLevelIndex(Math.min(level, MAX_LEVEL));
            setCount(0);
            setCountIndex(0);
            setProgress(progressIndex);
            setErrorNumber(0);
            setScore(0);
            setTimePause(false);
            setSuccessVisible(false);
            setWhVisible(false);
            setWheelVisible(false);
            setWordVisable(true);
            setWordStatus(false);
            setResultStatus(false);
            setMusk(true);
            // 关卡切换时，重置宝箱状态（新关卡默认未打开，实际状态会在进入时从 URL 参数获取）
            setBoxVisible(false);
            setBoxFood(null);
            // boxOpened 会在 URL 参数变化时更新，这里不重置
            setIsFifteenthLoaded(false);
            setAudio(null);
            skillRef.current = {
                0: { count: -1, countIndex: -1 },
                1: { count: -1, countIndex: -1 },
                2: { count: -1, countIndex: -1 },
                3: { count: -1, countIndex: -1 }
            };
            
            // 4. 重置计时器
            if (timerRef.current) {
                timerRef.current.reset?.();
            }
            
            // 5. 强制垃圾回收提示（浏览器可能会执行）
            if (window.gc) window.gc();
        }
    }, [level, progressIndex]);

    // 防止通过URL直接进入超出上限的关卡（测评模式仅 1 关，跳过）
    useEffect(() => {
        if (isAssessmentMode) return;
        if (levelIndex > MAX_LEVEL) {
            message.info(`当前仅开放前${MAX_LEVEL}关卡`);
            navigate(menuUrl);
        }
    }, [levelIndex, isAssessmentMode, menuUrl]);

    // 进度条颜色逻辑
    const color = [
        { progress: '#81A9E1', background: '#CDE0F3' },
        { progress: '#E790AD', background: '#F5D4D4' },
        { progress: '#B9D8E4', background: '#B9D8E4' },
        { progress: '#697FE0', background: '#BBCBE8' },
        { progress: 'rgb(0.1, 165, 0)', background: 'rgb(0.1, 165, 0, 0.8)' },
        { progress: '#8CA24D', background: '#8CA24D' },
        { progress: '#69D4E0', background: '#BBE3E8' },
    ]
    const colorIndex = () => {
        if (fromYingshi) return 0;
        if (type == 0 && (index == 0 || index == 1)) return 0;
        if (type == 0 && (index == 2)) return 1;
        if (type == 0 && (index == 3)) return 2;
        if (type == 1) return 3;
        if (type == 2 && (index == 0 || index == 1 || index == 2)) return 4;
        if (type == 2 && (index == 3)) return 5;
        return 0
    }

    // 背景图状态 - 动态加载
    const [currentBackgroundSrc, setCurrentBackgroundSrc] = useState(null);
    
    // 动态加载背景图（带 webp 降级）；影视入口按 serial_id 用对应页背景
    useEffect(() => {
        const key = fromYingshi && yingshiSerialId
            ? `yingshi-${getYingshiSlideIndex(yingshiSerialId)}`
            : `${type}-${index}`;
        let isMounted = true;
        
        const loadBackground = async () => {
            await checkWebpSupport();
            const webpSupported = isWebpSupported();
            
            const paths = webpSupported ? backgroundPathsWebp : backgroundPathsPng;
            const loader = paths[key] || paths['0-0'];
            
            try {
                const module = await loader();
                if (isMounted) {
                    setCurrentBackgroundSrc(module.default);
                }
            } catch (err) {
                console.error('背景图加载失败:', err);
                if (webpSupported) {
                    try {
                        const fallbackLoader = backgroundPathsPng[key] || backgroundPathsPng['0-0'];
                        const fallback = await fallbackLoader();
                        if (isMounted) {
                            setCurrentBackgroundSrc(fallback.default);
                        }
                    } catch (e) {
                        console.error('降级图片也加载失败:', e);
                    }
                }
            }
        };
        
        loadBackground();
        
        return () => {
            isMounted = false;
        };
    }, [type, index, fromYingshi, yingshiSerialId]);

    const tipClose = () => {
        // 关闭气泡，并在 localStorage 中设置对应类型的标志为 'true'
        setTipVisible(false)
        //localStorage.setItem('detail-tip', 'true');
    };

    // 组件挂载状态
    const isMountedRef = useRef(true);
    
    useEffect(() => {
        isMountedRef.current = true;
        
        // 组件卸载时清理所有资源
        return () => {
            isMountedRef.current = false;
            
            // 清理所有定时器
            if (wordtimerRef.current) {
                clearInterval(wordtimerRef.current);
                wordtimerRef.current = null;
            }
            if (audiotimerRef.current) {
                clearInterval(audiotimerRef.current);
                audiotimerRef.current = null;
            }
            // 清理选择图片相关的定时器
            if (selectTimerRef.current) {
                clearTimeout(selectTimerRef.current);
                selectTimerRef.current = null;
            }
            if (resultTimerRef.current) {
                clearTimeout(resultTimerRef.current);
                resultTimerRef.current = null;
            }
            if (errorTimerRef.current) {
                clearTimeout(errorTimerRef.current);
                errorTimerRef.current = null;
            }
            
            // 清理所有音频资源
            const audioElements = [
                audioRef.current,
                audioSuccessRef.current,
                audioErrorRef.current,
                audioGoonRef.current,
                magicAudioRef.current,
                audioOpenLiwuMusic.current
            ];
            
            audioElements.forEach(audio => {
                if (audio) {
                    audio.pause();
                    audio.src = '';
                    audio.load();
                }
            });
            
            // 取消进行中的网络请求
            if (controllerRef.current) {
                controllerRef.current.abort();
                controllerRef.current = null;
            }
            
            // 清理图片缓存 - 帮助垃圾回收
            setImagesList([]);
            setData([]);
            setCurrentBackgroundSrc(null);
        };
    }, []);

    useEffect(() => {
        let timer;
        if (!fromYingshi && levelIndex === 2 && type == 0) {
            timer = setTimeout(() => {
                setTipVisible(true);
            }, 800);
        }
        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [fromYingshi, levelIndex, type]);

    // 提前缓存抽奖素材
    // useEffect(() => {
    //     setTimeout(() => {
    //         setLuckAudio(luckymusic);
    //         setLuckySrc([luckyback, arrow]);
    //     }, 2000);
    // }, []);

    // 选错或者点击replay的重新播放音频 - 统一使用状态触发
    const [replayTrigger, setReplayTrigger] = useState(0);
    const replayLockRef = useRef(false);
    const replayTimersRef = useRef([]); // 收集定时器，卸载时清理，避免内存泄漏
    
    useEffect(() => {
        if (replayTrigger === 0) return;
        const _audio = audioRef.current;
        if (!_audio || !_audio.src) return;
        
        if (replayLockRef.current) return;
        replayLockRef.current = true;
        const timers = replayTimersRef.current;
        
        const cleanup = () => {
            replayLockRef.current = false;
        };
        
        const addTimer = (id) => {
            timers.push(id);
        };
        
        let onCanPlayHandler = null;
        
        const forcePlay = (retryCount = 0) => {
            if (!isMountedRef.current) {
                cleanup();
                return;
            }
            
            try {
                _audio.pause();
                _audio.currentTime = 0;
                
                const t1 = setTimeout(() => {
                    if (!isMountedRef.current || !_audio) {
                        cleanup();
                        return;
                    }
                    try {
                        const playPromise = _audio.play();
                        if (playPromise !== undefined) {
                            playPromise
                                .then(() => cleanup())
                                .catch((error) => {
                                    if (retryCount < 3 && isMountedRef.current) {
                                        const t = setTimeout(() => forcePlay(retryCount + 1), 100 * (retryCount + 1));
                                        addTimer(t);
                                    } else {
                                        console.warn('音频播放最终失败:', error);
                                        cleanup();
                                    }
                                });
                        } else {
                            cleanup();
                        }
                    } catch (e) {
                        if (retryCount < 3 && isMountedRef.current) {
                            const t = setTimeout(() => forcePlay(retryCount + 1), 100 * (retryCount + 1));
                            addTimer(t);
                        } else {
                            cleanup();
                        }
                    }
                }, 50);
                addTimer(t1);
            } catch (e) {
                if (retryCount < 3 && isMountedRef.current) {
                    const t = setTimeout(() => forcePlay(retryCount + 1), 100 * (retryCount + 1));
                    addTimer(t);
                } else {
                    cleanup();
                }
            }
        };
        
        if (_audio.readyState >= 2) {
            forcePlay();
        } else {
            onCanPlayHandler = () => {
                _audio.removeEventListener('canplay', onCanPlayHandler);
                _audio.removeEventListener('loadeddata', onCanPlayHandler);
                _audio.removeEventListener('canplaythrough', onCanPlayHandler);
                forcePlay();
            };
            _audio.addEventListener('canplay', onCanPlayHandler);
            _audio.addEventListener('loadeddata', onCanPlayHandler);
            _audio.addEventListener('canplaythrough', onCanPlayHandler);
            
            const t2 = setTimeout(() => {
                _audio.removeEventListener('canplay', onCanPlayHandler);
                _audio.removeEventListener('loadeddata', onCanPlayHandler);
                _audio.removeEventListener('canplaythrough', onCanPlayHandler);
                forcePlay();
            }, 1000);
            addTimer(t2);
        }
        
        wordRef.current?.reload();
        
        return () => {
            timers.forEach(clearTimeout);
            timers.length = 0;
            if (onCanPlayHandler && _audio) {
                _audio.removeEventListener('canplay', onCanPlayHandler);
                _audio.removeEventListener('loadeddata', onCanPlayHandler);
                _audio.removeEventListener('canplaythrough', onCanPlayHandler);
            }
        };
    }, [replayTrigger]);

    // 监听音频是否加载完毕
    useEffect(() => {
        const timer1 = setTimeout(() => {
            setIsFifteenthLoaded(true);
            setMusk(false);
        }, 600);
        // const timer2 = setTimeout(() => {
        //     setLazyData(true);
        // }, 2000);
        // 添加定时器清理
        return () => {
            clearTimeout(timer1);
            //clearTimeout(timer2);
        };
    }, [data]);

    // 首次加载或者切换音频
    useEffect(() => {
        const audio = audioRef.current;
        if (!isFifteenthLoaded || !audio || !words) return;
        
        let retryTimer = null;
        const playPromise = audio.play();
        if (playPromise !== undefined) {
            playPromise.catch(error => {
                if (!isMountedRef.current) return;
                console.warn('音频播放失败，尝试重新加载:', error);
                audio.load();
                retryTimer = setTimeout(() => {
                    if (isMountedRef.current) audio.play().catch(() => {});
                }, 100);
            });
        }
        wordRef.current?.reload();
        
        return () => {
            if (retryTimer) clearTimeout(retryTimer);
        };
    }, [audio, isFifteenthLoaded, words]);

    // 选择图片（节流 + 处理中锁，防止连点卡顿）
    const SELECT_PICTURE_THROTTLE_MS = 550;
    const selectPicture = useCallback((item, _index) => {
        const now = Date.now();
        const last = selectPictureThrottleRef.current;
        if (typeof last === 'number' && last > 0 && now - last < SELECT_PICTURE_THROTTLE_MS) {
            return;
        }
        if (selectPictureLockRef.current) return;
        selectPictureThrottleRef.current = now;
        selectPictureLockRef.current = true;

        if (wheelVisible) {
            selectPictureLockRef.current = false;
            return;
        }
        if (!wordStatus) {
            selectPictureLockRef.current = false;
            return message.info('请听完语音再作答');
        }

        // 清理之前的定时器
        if (selectTimerRef.current) clearTimeout(selectTimerRef.current);
        if (resultTimerRef.current) clearTimeout(resultTimerRef.current);
        if (errorTimerRef.current) clearTimeout(errorTimerRef.current);
        
        // 选对了
        if (normalizeAnswerText(item?.name) === normalizeAnswerText(words.join(' '))) {
            playSuccessSound() // Web Audio API
            setResultIndex(_index)
            setResultStatus(true)
            setWordStatus(false);
            
            selectTimerRef.current = setTimeout(() => {
                if (!isMountedRef.current) return; // 检查组件是否已卸载
                
                // 小的关节完成
                    if (countIndex + 1 >= data[0]?.images?.length) {
                    // 大的关节完成（该 outer 关的所有小关结束）
                     if (count + 1 >= data?.length) {
                        // demo 模式：不进入“完成/弹窗/奖励/倒计时超时”的链路，直接循环回第 1 关
                        if (demoMode) {
                            setSkill1Status(false);
                            selectPictureLockRef.current = false;
                            setTimePause(false);
                            setScore(0);
                            setErrorNumber(0);
                            setWhVisible(false);
                            setWheelVisible(false);
                            setSuccessVisible(false);
                            setBoxVisible(false);
                            setBoxFood(null);
                            setAssessmentCompleteVisible(false);
                            setAssessmentAiLoadingVisible(false);
                            setCount(0);
                            setCountIndex(0);
                            setProgress(0);
                            setLevelIndex(1);
                            return;
                        }
                        setSkill1Status(false);
                        selectPictureLockRef.current = false;
                        // 暂停游戏倒计时和时间记录倒计时
                        playLevelCompleteSoundSynthetic(); // 原先的 JS 模拟四音上行
                        playLevelCompleteSoundByStars(calcScore(errorNumber)); // 按星数 MP3，与上面同时播放
                        setTimePause(true);
                        setScore(calcScore(errorNumber));
                        setIsFifteenthLoaded(false);
                        skillRef.current = _skillRef;
                        const submitPayload = { serial_id: effectiveSerialId, number: levelIndex, score: calcScore(errorNumber), coin: getBaseCoin(levelIndex) };
                        // 闯关用时（秒）：用页面倒计时精确到秒，用于每日任务「50秒闯关」等
                        const timeLeft = timerRef.current?.getTimeLeft?.() ?? 180;
                        submitPayload.study_sec = Math.max(0, 180 - timeLeft);
                        // 测评：仅单词/短语级别按正确率写 area，0基础启蒙不传 area
                        if (isAssessmentMode && effectiveEngLevel !== '启蒙0基础') {
                            if (errorNumber == 0) submitPayload.area = JSON.stringify([7, 10, 11]);
                            else if ( errorNumber <= 5) submitPayload.area = JSON.stringify([7, 10]);
                        }
                        studyDoneSubmit(submitPayload).then(res => {
                            if (!isMountedRef.current) return; // 检查组件是否已卸载
                            if (res?.code !== 0) {
                                const errMsg = res?.msg || '';
                                if (errMsg.includes('今日访问关卡数已达上限')) {
                                    navigate(menuUrl + '&vip=5');
                                } else if (errMsg === 'course access denied') {
                                    message.info('完整学习体验需要会员权限支持哦！');
                                    navigate(menuUrl + '&vip=3');
                                } else {
                                    message.info(errMsg || '暂时无法完成闯关，请稍后再试');
                                    navigate(menuUrl);
                                }
                                return;
                            }
                            // 测评 s111 完成：清除 need_assessment_pending，切回时不再强制 welcome
                            if (isAssessmentMode) {
                                try { localStorage.removeItem('need_assessment_pending'); } catch (e) {}
                            }
                            // P0优化：获取基础金币信息
                            const baseCoinInfo = res?.data?.base_coin;
                            if (baseCoinInfo?.should_reward && baseCoinInfo?.coin) {
                                setBaseCoin(baseCoinInfo.coin);
                                // 发放基础金币后同步 Redux 用户信息，避免个人中心/商城显示滞后
                                getUserInfo({}).then((r) => {
                                    if (r?.data) dispatch(setUser(r.data));
                                }).catch(() => {});
                            } else {
                                setBaseCoin(0);
                            }
                            // 只有闯新关卡时才增加每日计数
                            if (levelIndex >= maxLevelRef.current) {
                                incrementDailyLevelLimit();
                                maxLevelRef.current = levelIndex + 1;
                            }
                            decreaseFirstSkillNumber(null, true)
                            
                            // 直接显示弹窗，减少延迟（拦截改到点击「下一关/继续闯关」时再跳 menu）
                            if (!isMountedRef.current) return;
                            
                            // 测评关卡：不抽奖、不闯关成功弹窗，先出假 AI loading（三条文案顺序各 1 秒，共 3 秒），结束后直接出测评结果弹窗
                            if (isAssessmentMode) {
                                setAssessmentAiLoadingTexts(ASSESSMENT_AI_LOADING_TEXTS);
                                setAssessmentAiLoadingVisible(true);
                                assessmentAiLoadingPendingRef.current = () => setAssessmentCompleteVisible(true);
                            } else if (res?.data?.reward['1'] && levelIndex !== 3) {
                                setWheelVisible(true);
                            } else if (isBoxLevel && !boxOpened) {
                                // 宝箱关卡，显示成功弹窗，用户可以在弹窗中开宝箱
                                setSuccessVisible(true);
                            } else {
                                // 普通关卡
                                setSuccessVisible(true);
                            }
                        }).catch(err => {
                            console.log(err,'err--01')
                        })
                    } else {
                        // 15 关测评：第 8 关、第 9 关结束后出假 AI loading（ASSESSMENT_AI_LOADING_MID_TEXTS）；7 关（0 基础）：第 3 小关结束后出
                        const is15LevelAssessment = isAssessmentMode && effectiveEngLevel !== '启蒙0基础';
                        const is7LevelAssessment = isAssessmentMode && effectiveEngLevel === '启蒙0基础';
                        const shouldShowMidAiLoading = (is15LevelAssessment && (count === 2 || count === 9)) || (is7LevelAssessment && count === 2);
                        if (shouldShowMidAiLoading) {
                            setTimePause(true);
                            setAssessmentAiLoadingTexts(ASSESSMENT_AI_LOADING_MID_TEXTS);
                            setAssessmentAiLoadingVisible(true);
                            const nextProgress = progress + progressIndex;
                            assessmentAiLoadingPendingRef.current = () => {
                                setTimePause(false);
                                setProgress(nextProgress);
                                setCount(count + 1);
                                setCountIndex(0);
                                setSkill1Status(false);
                                selectPictureLockRef.current = false;
                            };
                        } else {
                            setProgress(progress + progressIndex);
                            setCount(count + 1);
                            setCountIndex(0);
                            setSkill1Status(false);
                            selectPictureLockRef.current = false;
                        }
                    }
                } else {
                    if (Math.random() < 0.5) {
                        const prev = imagesListRef.current;
                        if (prev && prev.length > 1) {
                            const reversed = [...prev].reverse();
                            const changed = prev.some((p, i) => p !== reversed[i]);
                            if (changed) setImagesList(reversed);
                        }
                    }
                    setCountIndex(countIndex + 1);
                    setSkill1Status(false);
                    selectPictureLockRef.current = false;
                }
            }, 700);
        } else {
            window.oneWord = false
            setErrorNumber(errorNumber + 1);
            setResultIndex(_index)
            setResultStatus(false)
            // 确保音频播放，添加重试机制
            try {
                playErrorSound(); // Web Audio API
            } catch (e) {
                // 如果第一次失败，延迟重试一次
                setTimeout(() => {
                    try {
                        playErrorSound();
                    } catch (e2) {
                        console.warn('错误音效播放失败:', e2);
                    }
                }, 50);
            }
            setWordStatus(false);
            errorTimerRef.current = setTimeout(() => {
                if (!isMountedRef.current) return; // 检查组件是否已卸载
                selectPictureLockRef.current = false;
                // 随机反转图片顺序
                if (Math.random() < 0.5) {
                    setImagesList(prev => [...prev].reverse());
                }
                // 触发重新播放
                setReplayTrigger(prev => prev + 1);
            }, 700);
        }
        // 关闭选择状态
        resultTimerRef.current = setTimeout(() => {
            if (!isMountedRef.current) return;
            setResultIndex(-1);
        }, 700);
    }, [wordStatus, words, data, count, countIndex, progress, progressIndex, errorNumber, levelIndex, wheelVisible, effectiveEngLevel, isAssessmentMode]);


    // 格式化高亮文本
    const splitStringCustom = (_str) => {
        let str = _str?.trim()
        var firstWordMatch = str.match(/^\S+/);
        if (!firstWordMatch) {
            return [];
        }
        var firstWord = firstWordMatch[0];
        var remainingStr = str.slice(firstWord.length).trim();
        if (remainingStr === '') {
            return [firstWord];
        }
        var remainingWords = remainingStr.split(/\s+/);
        var resultArray = [firstWord].concat(remainingWords);
        return resultArray;
    }

    // 更换音频和文本（countIndex 变化时只更新音频和文本，不重置图片顺序，避免覆盖选对时的随机反转导致闪动）
    useEffect(() => {
        if (data?.length === 0 || data[0].src === '') return;
        if (wheelVisible) return; // 抽奖展示时（测评/正常闯关）不切音频，避免关卡内容继续播
        const audioSrc = data[count]?.audio?.[countIndex]?.src;
        console.log(data,audioSrc,'audioSrc=====')
        setAudio(resolveAssetUrl(OssAudio, audioSrc));
        setWords(splitStringCustom(data[count]?.text?.[countIndex]));
    }, [count, countIndex, data, wheelVisible]);

    // s111 测评关卡：第一题（第一个选项）时给用户一次操作提示，等 loading 消失后再出现
    useEffect(() => {
        if (!isAssessmentMode || assessmentFirstHintShownRef.current) return;
        if (musk) return; // 等 loading 消失后再提示
        if (!data?.length || !data[0]?.images?.length) return;
        if (count !== 0 || countIndex !== 0) return;
        assessmentFirstHintShownRef.current = true;
        message.info('请听语音，选择与听到内容相符的图片', 3);
    }, [isAssessmentMode, musk, data, count, countIndex]);

    // 仅换题或 data 变化时重置图片列表；同一题内 countIndex 变化不重置，保留随机反转结果
    useEffect(() => {
        if (data?.length === 0 || data[0].src === '') return;
        if (wheelVisible) return; // 抽奖展示时不切换图片列表
        setImagesList(data[count]?.images);
    }, [count, data, wheelVisible]);

    useEffect(() => {
        imagesListRef.current = imagesList;
    }, [imagesList]);

    useEffect(() => {
        getUserInfo({}).then(res => {
            if (isMountedRef.current) {
                setUser(res);
            }
        }).catch(err => {
            console.log(err,'err==02')
        })
        getGardenInfo({}).then(res => {
            if (isMountedRef.current) {
                setPet(res?.data)
                // 更新 localStorage
                if (res?.data) {
                    savePetInfoToStorage(res.data);
                }
            }
        }).catch(err => {
            console.log(err,'err==03')
        })
        
        // 不再检查宝箱状态，状态从 menu 页面传递
    }, []);
// 技能
    useEffect(() => {
        const list = calcSkill(pet?.garden_info?.PetInfo?.Phase)
        if (!list) return
        setskillList(list);
    }, [pet]);

    // 权限
    useEffect(() => {
        const data = user?.data;
        if (!data) return;
        const hasAllLevelAccess = canAccessAllLevels(data);

        const isNewLevel = levelIndex >= maxLevelRef.current;
        if (isNewLevel && data?.vip_expire !== 111 && !hasAllLevelAccess && !checkDailyLevelLimit()) {
            navigate(menuUrl + '&vip=5');
            return;
        }

        // 目前关数上限、111为测试号
        // if (levelIndex > 200 && data?.vip_expire !== 111) {
        //     navigate(`/menu?type=${type}&index=${index}&vip=4`);
        // }

        // 永久会员和内部账号
        if (hasAllLevelAccess || data?.vip_expire == 0 || data?.vip_expire == 111 || data?.vip_expire == 222) return
        
        // vip_expire == 1 表示非会员（因为unsigned不能存储-1，所以用1表示）
        if (data?.vip_expire == 1) {
            navigate(menuUrl + '&vip=3');
            return;
        }
        
        // 其他值（> 0 且不等于 111/222）表示有效期会员，需要判断是否过期
        if (data?.vip_expire > 0 && data?.vip_expire != 111 && data?.vip_expire != 222) {
            // 会员已过期
            if (data?.is_expire) {
                navigate(menuUrl + '&vip=1');
            }
            // 会员未过期，可以继续
        }
    }, [levelIndex, user]);

    const handleBack = () => {
        if (isAssessmentMode) {
            navigate('/welcome');
            return;
        }
        navigate(menuUrl);
    };

    const calcScore = (errorNumber) => {
        if (errorNumber == 0) return 3
        if (1 <= errorNumber && errorNumber < 6) return 2
        if (6 <= errorNumber && errorNumber < 20) return 1
        if (20 <= errorNumber) return 0
    }

    // 重听音频 - 统一使用replayTrigger机制
    const repaly = () => {
        // 使用统一的replayTrigger机制，确保播放稳定
        setReplayTrigger(prev => prev + 1);
    }

    // 继续下一关接口
    useEffect(() => {
        // 抽奖、金币弹窗或测评完成弹窗展示时不再拉关卡数据，避免切换过早导致播放第一关音频
        if (wheelVisible || whVisible || assessmentCompleteVisible) {
            return;
        }
        // 同一关卡在已加载的情况下不重复拉取，避免因 modal 状态切换造成音频重播
        if (lastLoadedLevelRef.current === levelIndex) {
            return;
        }
        if(controllerRef.current) {
            controllerRef.current.abort();
        }        
        const controller = new AbortController();
        controllerRef.current = controller;
        const id = effectiveSerialId;
        
        // 延迟加载，给浏览器时间回收上一关的内存
        const loadDelay = prevLevelRef.current !== level ? 200 : 0;
        
        const loadTimer = setTimeout(() => {
            getCourseDetail({   
                serial_id: id,
                number: levelIndex
              }, { signal: controller.signal }).then(res => {
                if (!isMountedRef.current) return; // 检查组件是否已卸载
                if (res?.code !== 0) {
                    const errMsg = res?.msg || '';
                    if (errMsg.includes('今日访问关卡数已达上限')) {
                        navigate(menuUrl + '&vip=5');
                    } else if (errMsg === 'course access denied') {
                        message.info('完整学习体验需要会员权限支持哦！');
                        navigate(menuUrl + '&vip=3');
                    } else {
                        message.info(errMsg || '暂时无法进入该关卡');
                        navigate(menuUrl);
                    }
                    return;
                }
                
                // 测评(111)：0基础启蒙=7小关不写area，单词/短语=15小关按正确率写area；非测评：10/6小关
                const rawDetail = res?.data?.detail || [];
                let detail = rawDetail;
                if (id === 111) {
                    detail = effectiveEngLevel === '启蒙0基础' ? rawDetail.slice(0, ASSESSMENT_SUB_LEVELS) : rawDetail.slice(0, 15);
                } else {
                    if (rawDetail.length === 15) detail = rawDetail.slice(0, 10);   // 2选项：砍掉11-15
                    if (rawDetail.length === 8) detail = rawDetail.slice(0, 6);     // 4选项：砍掉7-8
                }
                const length = detail?.length;
                // 进度条每格比例：6小关=100/6，7小关=100/7，10小关=10，15小关=6.67
                const _index = length === 6 ? (100 / 6) : (length === 7 ? (100 / 7) : (length === 10 ? 10 : (length === 15 ? (100 / 15) : 6.67)))
                const newData = detail.map((stage, i) => ({
                    ...stage,
                    images: stage.images?.map((item, j) => 
                        item ? { ...item, src: `/s${id}/n${levelIndex}/i${i + 1}_image${j + 1}.jpg` } : item
                    ),
                    audio: stage.audio?.map((item, j) => 
                        item ? {
                            ...item,
                            src: shouldUseCourseAudioSrc(item.src)
                                ? (item.src || `/s${id}/n${levelIndex}/i${i + 1}_audio${j + 1}.mp3`)
                                : `/s${id}/n${levelIndex}/i${i + 1}_audio${j + 1}.mp3`
                        } : item
                    ),
                }));
                
                setProgressIndex(_index);
                if (demoMode) {
                    // demo 从 0% 开始循环，不进入“完成”链路
                    setProgress(0);
                } else {
                    setProgress(_index); // 使用新计算的值而非旧状态
                }
                setData(shuffleNestedArrays(newData));
                setCount(0);
                setCountIndex(0);
                lastLoadedLevelRef.current = levelIndex;
            }).catch(error => {
                if (error.name !== 'AbortError') {
                    console.error('API请求错误:', error);
                }
            });
        }, loadDelay);
        
        return () => {
            clearTimeout(loadTimer);
            controller.abort();
            controllerRef.current = null;
        }
    }, [levelIndex, effectiveSerialId, (effectiveSerialId === 111 ? effectiveEngLevel : null), isAssessmentMode, wheelVisible, whVisible, assessmentCompleteVisible, demoMode]);

    // 关卡小人头像；影视入口无 type，用 avator1 兜底
    const avator = fromYingshi || type == null || type === undefined ? avator1 : (type == 0 ? avator1 : avator2);

    const timeOutOk = useCallback(() => {
        setCount(0);
        setCountIndex(0);
        setProgress(progressIndex);
    },[progressIndex])

    const wordcb = useCallback(() => {
        setWordStatus(true);
    }, [])

    const whOk = () => {
        stopDetailSuccSound();
        setWhVisible(false);
        setWheelVisible(false);
        
        // 测评抽奖完直接出测评弹窗，不会走到这里
        // 如果当前关卡也是宝箱关卡且未打开，显示成功弹窗让用户开宝箱
        if (isBoxLevel && !boxOpened) {
            setTimeout(() => {
                if (isMountedRef.current) setSuccessVisible(true);
            }, 300);
            return;
        }
        
        // 闯完上限关卡后自动跳转到menu
        if (levelIndex >= MAX_LEVEL) {
            message.success(`恭喜你完成了当前开放的全部${MAX_LEVEL}关！`);
            navigate(menuUrl);
            return;
        }
        reset()
    }

    const wheelOk = useCallback((coin) => {
        stopDetailSuccSound(); // 抽奖完成展示金币弹窗前终止闯关成功音
        setCoin(coin);
        // 积分不可擅自修改，一旦修改要立刻还原！！！
        studyDoneReward({ serial_id: effectiveSerialId, number: levelIndex, coin: coin, type: 1 }).then(() => {
            if (!isMountedRef.current) return;
            // 抽奖发金币后拉取最新用户信息并更新 Redux，避免个人中心/商城显示的金币不增加或滞后
            getUserInfo({}).then((r) => {
                if (r?.data) dispatch(setUser(r.data));
            }).catch(() => {});
            // 测评：抽奖完直接出测评特殊弹窗，不经过金币弹窗
            if (isAssessmentMode) {
                setAssessmentCompleteVisible(true);
                return;
            }
            if (isBoxLevel && !boxOpened) {
                setTimeout(() => {
                    if (isMountedRef.current) setSuccessVisible(true);
                }, 500);
                return;
            }
            setWhVisible(true);
        });
    }, [coin, levelIndex, isBoxLevel, boxOpened, isAssessmentMode, dispatch]);

    const reset = () => {
        stopDetailSuccSound();
        // 停止当前音频
        if (audioRef.current) {
            audioRef.current.pause();
        }
        
        const nextLevel = levelIndex + 1;

        // 点击「下一关/继续闯关」时再检查每日新关卡限制：
        // 旧关卡继续玩不计入、不拦截；只有下一关是新关时才消耗/校验每日 30 个新关额度。
        const hasAllLevelAccess = canAccessAllLevels(user?.data);
        const isNextLevelNew = nextLevel >= maxLevelRef.current;
        if (isNextLevelNew && !checkDailyLevelLimit() && user?.data?.vip_expire !== 111 && !hasAllLevelAccess) {
            navigate(menuUrl + '&vip=5');
            return;
        }
        
        if (nextLevel > MAX_LEVEL) {
            message.success(`恭喜你完成了当前开放的全部${MAX_LEVEL}关！`);
            navigate(menuUrl);
            return;
        }
        // 下一关默认未打开宝箱（如果是从 menu 进入的，会在 URL 参数中传递正确状态）
        navigate(buildDetailUrl(nextLevel, maxLevelRef.current, false));
    }

    const susseccOk = () => {
        stopDetailSuccSound();
        setSuccessVisible(false);
        // 如果宝箱已打开但弹窗未关闭，先关闭宝箱弹窗
        if (boxVisible) {
            setBoxVisible(false);
        }
        // 测评模式：通关后跳转 pet
        if (isAssessmentMode) {
            navigate('/pet');
            return;
        }
        // 闯完上限关卡后自动跳转到menu
        if (levelIndex >= MAX_LEVEL) {
            message.success(`恭喜你完成了当前开放的全部${MAX_LEVEL}关！`);
            navigate(menuUrl);
            return;
        }
        reset()
    };

    const successCancel = () => {
        stopDetailSuccSound();
        if (isAssessmentMode) {
            navigate('/welcome');
            return;
        }
        navigate(menuUrl);
    }
    const whCancel = () => {
        stopDetailSuccSound();
        navigate(`/pet`);
    }

    const boxFeedOk = () => {
        stopDetailSuccSound();
        setBoxVisible(false);
        navigate(`/pet`);
    }


    // 随机鼓励语 - 强化情感连接
    const encouragementTexts = [
        '悟空给你点赞！',
        '悟空说你好棒！',
        '悟空为你骄傲！',
        '悟空夸你厉害！',
        '悟空在为你加油！',
        '悟空为你感到开心！',
        '悟空说继续加油！',
        '悟空在看着你成长！',
    ];
    const randomEncouragement = useMemo(() => {
        return encouragementTexts[Math.floor(Math.random() * encouragementTexts.length)];
    }, [levelIndex]); // 每关随机一次

    // 使用 useMemo 缓存弹窗内容，避免每次渲染重新创建 JSX
    const successContent = useMemo(() => {
        // 如果是宝箱关卡且未打开，显示简化版：星星+开宝箱按钮
        if (isBoxLevel && !boxOpened) {
            return (
                <div className='detail-success'>
                    <div>挑战成功!</div>
                    <div className="star">
                        {[0, 1, 2].map((j) => (
                            <div className='star-item' key={j}>
                                <img src={j < score ? star : unstar} loading="lazy" />
                            </div>
                        ))}
                    </div>
                    <div className='detail-success-box-hint'>
                        <div className='box-hint-text'>🎁 恭喜你获得了宝箱！</div>
                        <div 
                            className='box-open-button' 
                            onClick={(e) => {
                                e.stopPropagation();
                                handleOpenBox();
                            }}
                        >
                            <img src={unopenLiwu} alt="宝箱" className='box-icon' />
                            <span>点击打开宝箱</span>
                        </div>
                    </div>
                </div>
            );
        }
        
        // 普通关卡：显示完整内容
        return (
            <div className='detail-success'>
                {/* 移除顶部卡通头像，只保留悟空 */}
                <div>挑战成功!</div>
                <div className="star">
                    {[0, 1, 2].map((j) => (
                        <div className='star-item' key={j}>
                            <img src={j < score ? star : unstar} loading="lazy" />
                        </div>
                    ))}
                </div>
                {/* P0优化：显示基础金币和悟空 - 紧凑布局 */}
                {baseCoin > 0 && (
                    <div className='detail-success-base-coin'>
                        {/* 悟空头像和鼓励语合并一行 */}
                        <div className='base-coin-pet-compact'>
                            <div className='pet-wrapper'>
                                <PetAvatar pet={pet} className='pet-avatar-compact' />
                                <div className='pet-glow-effect-compact'></div>
                            </div>
                            <div className='encouragement-text-compact'>{randomEncouragement}</div>
                        </div>
                        {/* 金币奖励 */}
                        <div className='base-coin-amount-compact'>
                            <img src={gold} alt="金币" className='coin-icon-img' />
                            <span className='coin-text'>+{baseCoin} 金币</span>
                        </div>
                    </div>
                )}
            </div>
        );
    }, [score, baseCoin, pet, randomEncouragement, isBoxLevel, boxOpened, handleOpenBox]);

    const whContent = useMemo(() => (
        <div className='detail-success detail-success--lottery'>
            <div className='icon icon--smile'><img src={silme} alt="笑脸" loading="lazy" /></div>
            <div className='lottery-text'>
                <div>恭喜获得 <span className='number'>{coin}</span> 枚金币！</div>
            </div>
        </div>
    ), [coin]);
    
    // 使用公共组件 - 与 Menu 页面保持一致，支持 30% 食物展示
    const boxContent = useMemo(() => (
        <TreasureBoxModal coin={boxCoin} food={boxFood} />
    ), [boxCoin, boxFood]);

    // 测评通关专用弹窗：无抽奖无宝箱
    const assessmentCompleteContent = useMemo(() => (
        <div className='detail-success detail-assessment-complete'>
            <div className='icon icon--smile'><img src={silme} alt="笑脸" loading="lazy" /></div>
            <div className='assessment-complete-line1'>太棒了！<span className="highlight">精准评估</span>看得出你很有语言天赋！</div>
            <div className='assessment-complete-line2'>建议强化<span className="highlight">听辨输入 + 高频词巩固</span>训练</div>
        </div>
    ), []);


    const decreaseFirstSkillNumber = (index, reset) => {
        let newSkillList;
        if (reset) {
            newSkillList = skillList.map((skill, _index) => {
                // 后续加所有技能逻辑
                return { ...skill, number: 1 };
            });
        } else {
            newSkillList = skillList.map((skill, _index) => {
                if (_index === index) {
                    return { ...skill, number: skill.number - 1 };
                }
                return skill; // 对于其他对象，直接返回原对象
            });
        }


        // 更新状态
        setskillList(newSkillList);
    };

    const skill = (index) => {
        // (count, skillRef.current[index]?.count, countIndex, skillRef.current[index]?.countIndex, 'skill')
        if (count === skillRef.current[index]?.count && index == 0) {
            if (skillRef.current[index]?.countIndex === countIndex) {
                return message.info('请勿重复使用技能')
            }
        }
        skillRef.current[index] = { count: count, countIndex: countIndex };
        switch (index) {
            case 0:
                if (skillList[index].number === 0) return message.info('很遗憾，悟空没有技能可用了')
                // setSkillGifStatus(true);
                playSkillSound(); // Web Audio API 轻量音效
                setSkill1Status(true);
                // setTimeout(() => {
                //     setSkillGifStatus(false);
                //     setSkill1Status(true);
                // }, 1900);
                decreaseFirstSkillNumber(index);
                setSkillVisible(false);
                return
            case 1:
                if (!skillList[index].visible) return message.info('可以升级悟空来获取技能')
                message.info('被动技能，无法主动触发')
                //magicAudioRef.current.play();
                return
            case 2:
                if (!skillList[index].visible) return message.info('可以升级悟空来获取技能')
                //magicAudioRef.current.play();
                message.info('被动技能，无法主动触发')
                return
            case 3:
                if (!skillList[index].visible) return message.info('可以升级悟空来获取技能')
                //magicAudioRef.current.play();
                message.info('被动技能，无法主动触发')
                return
            default:

        }
    }

    const skillContent = <div className='detail-skillcontent'>
        {skillList?.map((item, index) => (
            <div className='item' key={item?.src} onClick={() => skill(index)}>
                <img src={ossImageUrl(item?.visible ? item?.src : OssOther + '/image/skill/unknowskill.png')} />
                {item?.visible ? (index >= 1 ?
                    <div className='name'>
                        <div style={{ fontWeight: '600', fontSize: '1.6rem' }}>{item?.name}</div>
                        <div style={{ fontSize: '1.2rem' }}>等级: {item?.level || 0}</div>
                    </div> :
                    <div className='number'>
                        <div style={{ fontWeight: '600', fontSize: '1.6rem' }}> {item?.name}</div>
                        <div style={{ fontSize: '1.2rem' }}> 数量: {item?.number}</div>
                    </div>)
                    :
                    <div>???</div>}
            </div>
        ))}
    </div>;
   // console.log('---父组件渲染')
    return (
        <div className='detail-container'>
            {musk ? <Loadding pet={pet} /> : null}
            <AssessmentAiLoading
                visible={debugAiLoading || assessmentAiLoadingVisible}
                text={assessmentAiLoadingText || (debugAiLoading ? ASSESSMENT_AI_LOADING_TEXTS[0] : '')}
                texts={assessmentAiLoadingTexts}
                onComplete={debugAiLoading ? () => {} : onAssessmentAiLoadingComplete}
            />
            {musk ? null : <img src={currentBackgroundSrc} className='detail-background' />}
            {/* 右上角悟空头像 */}
            {musk ? null : (
                <div className='detail-avatar-top-right'>
                    <PetAvatar pet={pet} className='detail-top-avatar' />
                </div>
            )}
            {musk ? null : <div className='detail-content' style={{ marginTop: imagesList?.length == 4 ? '18rem' : '20rem' }}>
                {/* <div className='detail-level'>第{level}关</div> */}
                <div className='detail-level'>
                    <img src={empty} />
                    <div className='level'>第<span style={{ margin: `0 0.5rem` }}>{levelIndex}</span>关</div>
                </div>
                <div className='detail-content-control'>
                    <div className='detail-content-control-top'>
                        {!demoMode ? (
                            <Timer
                                levelIndex={levelIndex}
                                name={user?.name}
                                timeoutcb={timeOutOk}
                                pause={timePause}
                                ref={timerRef}
                                isAssessmentMode={isAssessmentMode}
                                serialId={effectiveSerialId}
                                menuUrl={menuUrl}
                            />
                        ) : null}
                        <div className='detail-content-control-voice' onClick={repaly}>
                            <img src={music} />
                        </div>
                    </div>
                    <div className='detail-content-control-progress'>
                        <div className='progress-header'>
                            <div className='progress-number'>{count + 1} / {data?.length}</div>
                        </div>
                        <div className='progress'>
                            <div className='progress-content' style={{ width: `${progress}%`, background: color[colorIndex()].progress }}></div>
                        </div>
                    </div>
                    {/* 距离下一个宝箱进度条（可通过 SHOW_BOX_REMAINING_COUNTDOWN 隐藏） */}
                    {SHOW_BOX_REMAINING_COUNTDOWN && (() => {
                        // 如果是宝箱关卡，显示特殊提示
                        if (isBoxLevel) {
                            if (boxOpened) {
                                // 已打开宝箱
                                return (
                                    <div className='detail-reward-progress'>
                                        <div className='reward-progress-label reward-box-completed'>
                                            ✅ 宝箱已打开！
                                        </div>
                                        <div className='reward-progress-bar'>
                                            <div 
                                                className='reward-progress-content reward-progress-full' 
                                                style={{ width: '100%' }}
                                            ></div>
                                        </div>
                                    </div>
                                );
                            } else {
                                // 未打开宝箱
                                return (
                                    <div className='detail-reward-progress'>
                                        <div className='reward-progress-label reward-box-ready'>
                                            🎁 这是宝箱关卡！完成关卡后可以打开宝箱
                                        </div>
                                        <div className='reward-progress-bar'>
                                            <div 
                                                className='reward-progress-content reward-progress-ready' 
                                                style={{ width: '100%' }}
                                            ></div>
                                        </div>
                                    </div>
                                );
                            }
                        }
                        
                        // 非宝箱关卡，显示距离下一个宝箱的进度
                        const { nextRewardLevel, remaining } = getNextRewardInfo();
                        
                        // 如果下一个宝箱关卡超过500关或不存在，不显示进度提示
                        if (nextRewardLevel === null || nextRewardLevel > 500) {
                            return null;
                        }
                        
                        const maxRemaining = levelIndex <= 30 ? Math.max(4, remaining) : Math.max(6, remaining);
                        const rewardProgress = Math.min(100, Math.max(0, ((maxRemaining - remaining) / maxRemaining) * 100));
                        // 更友好的文字表达
                        const progressText = remaining === 1 
                            ? '🎁 再完成1关就能开宝箱啦！'
                            : `🎁 只有${remaining}关就到宝箱啦！`;
                        return (
                            <div className='detail-reward-progress'>
                                <div className='reward-progress-label'>
                                    {progressText}
                                </div>
                                <div className='reward-progress-bar'>
                                    <div 
                                        className='reward-progress-content' 
                                        style={{ width: `${rewardProgress}%` }}
                                    ></div>
                                </div>
                            </div>
                        );
                    })()}
                    <div className='detail-content-control-bottom'>
                        <div className='right' onClick={() => setWordVisable(!wordVisable)}>
                            {wordVisable ? <img src={check} /> : <img src={uncheck} />}
                            <div className='font'>显示英文</div>
                        </div>
                    </div>
                </div>
                <div className='detail-content-picture'>
                    {imagesList?.map((item, index) => {
                        return <div
                            className={`detail-content-picture-item ${skill1Status && normalizeAnswerText(item?.name) === normalizeAnswerText(data[count]?.text?.[countIndex]) ? 'show-overlay' : ''} ${normalizeAnswerText(item?.name) === normalizeAnswerText(words.join(' ')) && type == 0 && levelIndex == 1 && count == 0 && countIndex == 0 && wordStatus ? 'guide' : ''}`}
                            style={{ height: imagesList?.length == 4 ? '19rem' : '25.3rem' }}
                            key={item?.src}
                            onClick={() => selectPicture(item, index)}>
                            <img 
                                src={ossImageUrl(OssImg + item?.src)} 
                                loading="lazy"
                                decoding="async"
                            />
                            {demoMode && imagesList?.length === 2 && index < 2 ? (
                                <span className="detail-demo-choice-num" aria-hidden>
                                    {index + 1}
                                </span>
                            ) : null}
                            {resultIndex === index && resultStatus ? <div className='result'><img src={right} /></div> : null}
                            {resultIndex === index && !resultStatus ? <div className='result'><img src={wrong} /></div> : null}
                            <>{item?.text?.name}</>
                        </div>
                    })}
                </div>
                <Word text={data[count]?.text?.[countIndex]} wordVisable={wordVisable} ref={wordRef} wordcb={wordcb}/>
            </div>}
            <img src={back} className='detail-back' onClick={handleBack} />
            <Tooltip
                placement="left"
                title={
                    <div>
                        {<div>遇到难题啦？快用悟空的魔法技能来帮你闯关吧</div>}
                        {/* <br /> */}
                        <Button type="primary" onClick={() => { tipClose(); setSkillVisible(true); }} size="small">使用</Button>
                        <div style={{ clear: "both" }}></div>
                    </div>
                }
                open={tipVisible}
            >
                <div className='detail-magic' onClick={() => { setSkillVisible(true) }}>
                    <img src={magic} alt='' />
                </div>
            </Tooltip>
            <audio ref={audioRef} src={audio} controls className='detail-audio' preload='auto' />
            <audio ref={audioOpenLiwuMusic} src={openLiwuMusic} preload='auto' />
            {/* 选对/选错音效改用 Web Audio API */}
            {/* 技能音效改用 Web Audio API */}
            {/* <img src={skillGifStatus ? OssOther + '/image/skill_1.gif' :null} className='skill-gif' /> */}
            {/* 不可见区域，用于提前加载图片与音频 */}

            {/* 不可见区域，用于提前加载图片与音频 */}
            <WkModal
                visible={successVisible}
                onOk={susseccOk}
                onCancel={successCancel}
                content={successContent}
                okText={'继续闯关'}
                destroyOnClose={true}
                tongquStyle
            />
            <WkModal
                visible={assessmentCompleteVisible}
                onOk={() => {
                    stopDetailSuccSound();
                    setAssessmentCompleteVisible(false);
                    navigate('/pet');
                }}
                onCancel={() => {
                    stopDetailSuccSound();
                    setAssessmentCompleteVisible(false);
                    navigate('/pet');
                }}
                content={assessmentCompleteContent}
                okText={'解锁悟空'}
                cls="detail-unlock-wukong-modal"
                destroyOnClose={true}
                tongquStyle
            />
            <WkModal
                visible={whVisible}
                onOk={whOk}
                onBtn={whCancel}
                onBtnVisable={true}
                content={whContent}
                isGuide={false}
                onCancel={successCancel}
                okText={'继续闯关'}
                cancelText={'大圣庄园'}
                cancelVisble={true}
                destroyOnClose={true}
                tongquStyle
            />
            <Wheel
                onOk={wheelOk}
                skill={skillList}
                visible={wheelVisible}
                setWheelVisible={setWheelVisible}
                pet={pet}
                fromYingshi={fromYingshi}
                levelIndex={levelIndex}
            />
            <WkModal
                visible={skillVisible}
                content={skillContent}
                onOk={() => setSkillVisible(false)}
                onCancel={() => setSkillVisible(false)}
                okText="关闭"
                cancelVisble={false}
                tongquStyle
            />
            {/* 全屏烟花效果 */}
            <Fireworks visible={boxVisible} duration={3000} />
            {/* 宝箱弹窗 */}
            <WkModal
                visible={boxVisible}
                onOk={() => {
                    stopDetailSuccSound();
                    setBoxVisible(false);
                    if (levelIndex >= MAX_LEVEL) {
                        message.success(`恭喜你完成了当前开放的全部${MAX_LEVEL}关！`);
                        navigate(menuUrl);
                        return;
                    }
                    reset();
                }}
                onCancel={() => {
                    stopDetailSuccSound();
                    setBoxVisible(false);
                    if (levelIndex >= MAX_LEVEL) {
                        message.success(`恭喜你完成了当前开放的全部${MAX_LEVEL}关！`);
                        navigate(menuUrl);
                        return;
                    }
                    reset();
                }}
                onBtn={boxFeedOk}
                onBtnVisable={true}
                isGuide={true}
                cancelText={'去升级悟空'}
                content={boxContent}
                okText={'继续闯关'}
                destroyOnClose={true}
                tongquStyle
            />
        </div >
    );
};

export default Detail;
